import React, { Fragment } from 'react';

import SideNav from '../../Components/SideNav';
import View from './View';

const Mensajes = () => {
    return (
        <Fragment>
            <SideNav />
            <div className='row'>
                <View />
            </div>
        </Fragment>
    );
};

export default Mensajes;
